module.exports = __webpack_public_path__ + "media/public/tab-eye-651c6097.png";